export enum MachineEventType {
	Breakdown = 10,
	Service = 20,
	StatutoryOrRegulatory = 30,
	TPM = 40,
}